import React, { useEffect, useState } from "react";
import {
  Card,
  Tabs,
  Space,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Input,
  message,
} from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { EyeOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
function StudentTable() {
  const [activeTab, setActiveTab] = useState("students");
  const [tableData, setTableData] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleUpdatePassword, setVisibleUpdatePassword] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const columns = [
    {
      title: "Student Name",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => viewRecord(record)}>
                <EyeOutlined />
              </Button>
              <Button size="small" onClick={() => updatePasswordRecord(record)}>
                Update Password
              </Button>
              {(activeTab == "not_completed_signup" ||
                activeTab == "payment_not_done") && (
                <Button size="small" onClick={() => sendEmail(record)}>
                  <MailOutlined />
                </Button>
              )}
            </Space>
          }
        </>
      ),
    },
  ];

  const [studentsResponse, getStudentsRequest] = useApi(
    `/admin/student?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );
  const [notCompletedSignupResponse, getNonCompletedSignupsRequest] = useApi(
    `/admin/student/not-completed?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );
  const [paymentNotDoneResponse, getPaymentNotDoneRequest] = useApi(
    `/admin/student/payment-not-done?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [notActiveResponse, getNotActiveRequest] = useApi(
    `/admin/student/not-active-subscription?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );
  const [updatePasswordResponse, updatePasswordRequest] = useApi();
  const [emailResponse, emailRequest] = useApi();

  useEffect(() => {
    getStudentsRequest();
  }, []);

  const viewRecord = (record) => {
    navigate(`/portal/students/detail/${record.id}`);
  };

  const updatePasswordRecord = (record) => {
    setVisibleUpdatePassword(true);
    setSelectedRecord(record);
  };

  const handleCancelUpdatePassword = () => {
    setVisibleUpdatePassword(false);
    setSelectedRecord(null);
    form.resetFields();
  };

  const sendEmail = (record) => {
    let data = {
      tab: activeTab,
    };
    emailRequest(
      data,
      API_METHODS.POST,
      `/admin/student/send-email/${record.id}`
    );
  };

  useEffect(() => {
    const data =
      studentsResponse.data !== BLANK_VALUE ? studentsResponse.data : [];
    const pagination =
      studentsResponse.pagination !== BLANK_VALUE
        ? studentsResponse.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [studentsResponse]);

  useEffect(() => {
    const data =
      notCompletedSignupResponse.data !== BLANK_VALUE
        ? notCompletedSignupResponse.data
        : [];
    const pagination =
      notCompletedSignupResponse.pagination !== BLANK_VALUE
        ? notCompletedSignupResponse.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [notCompletedSignupResponse]);

  useEffect(() => {
    const data =
      paymentNotDoneResponse.data !== BLANK_VALUE
        ? paymentNotDoneResponse.data
        : [];
    const pagination =
      paymentNotDoneResponse.pagination !== BLANK_VALUE
        ? paymentNotDoneResponse.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [paymentNotDoneResponse]);

  useEffect(() => {
    const data =
      notActiveResponse.data !== BLANK_VALUE ? notActiveResponse.data : [];
    const pagination =
      notActiveResponse.pagination !== BLANK_VALUE
        ? notActiveResponse.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [notActiveResponse]);

  useEffect(() => {
    if (updatePasswordResponse.data && !updatePasswordResponse.isLoading) {
      setVisibleUpdatePassword(false);
      setSelectedRecord(null);
      getStudentsRequest();
      setCurrentPage(1);
      form.resetFields();
      setActiveTab("students");
      messageApi.open({
        type: "success",
        content: "Student Password updated successfully",
      });
    }
  }, [updatePasswordResponse]);

  useEffect(() => {
    if (emailResponse.data && !emailResponse.isLoading) {
      messageApi.open({
        type: "success",
        content: "Email Sent Successfully.",
      });
    }
  }, [emailResponse]);

  const updatePassword = () => {
    form.validateFields().then((values) => {
      if (selectedRecord) {
        updatePasswordRequest(
          values,
          API_METHODS.PUT,
          `/admin/student/change-password/${
            selectedRecord && selectedRecord.id
          }`
        );
      }
    });
  };

  const onPaginationChange = (page) => {
    if (activeTab == "not_completed_signup") {
      getNonCompletedSignupsRequest(
        null,
        API_METHODS.GET,
        `/admin/student/not-completed?pageNumber=${page.current}`
      );
    } else if (activeTab == "payment_not_done") {
      getPaymentNotDoneRequest(
        null,
        API_METHODS.GET,
        `/admin/student/payment-not-done?pageNumber=${page.current}`
      );
    } else if (activeTab == "not_active") {
      getNotActiveRequest(
        null,
        API_METHODS.GET,
        `/admin/student/not-active-subscription?pageNumber=${page.current}`
      );
    } else {
      getStudentsRequest(
        null,
        API_METHODS.GET,
        `/admin/student?pageNumber=${page.current}`
      );
    }
    setCurrentPage(page.current);
  };

  const onTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    if (key == "not_completed_signup") {
      getNonCompletedSignupsRequest();
    } else if (key == "payment_not_done") {
      getPaymentNotDoneRequest();
    } else if (key == "not_active") {
      getNotActiveRequest();
    } else {
      getStudentsRequest();
    }
  };

  const items = [
    {
      key: "students",
      label: "Active Students",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={studentsResponse.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: "payment_not_done",
      label: "Payment Not Done",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={paymentNotDoneResponse.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: "not_completed_signup",
      label: "Not Completed Signup",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={notCompletedSignupResponse.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: "not_active",
      label: "Not Active Subscription",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={notActiveResponse.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
  ];

  return (
    <Card title="Students">
      {contextHolder}
      <Tabs
        defaultActiveKey="students"
        activeKey={activeTab}
        items={items}
        onChange={onTabChange}
      />

      {visibleUpdatePassword && (
        <Modal
          title={`Update Password for- ${selectedRecord.name}`}
          open={visibleUpdatePassword}
          onOk={updatePassword}
          onCancel={handleCancelUpdatePassword}
          width={800}
          okText="Update Password"
          destroyOnClose={true}
        >
          <Form layout="vertical" form={form}>
            <Row>
              <Col offset={4} span={12}>
                <Form.Item
                  name="password"
                  label="New Password"
                  rules={[
                    { required: true, message: "New Password is required." },
                    {
                      max: 20,
                      message:
                        "New Password should be maximum of 20 characters.",
                    },
                  ]}
                >
                  <Input placeholder="Password" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      )}
    </Card>
  );
}

export default StudentTable;
